import { useEffect } from 'react';
import { createHook, createStore, type Action } from 'react-sweet-state';
import { SERVICE_DESK } from '@atlassian/jira-shared-types';
import { useTenantContext } from '@atlassian/jira-tenant-context-controller';
import { getFirstProject } from './get-first-project';

export interface FirstProject {
	projectId: string;
	projectTemplateKey: string;
}

type State = {
	error?: boolean;
	firstProject?: FirstProject;
};

const initialState: State = {
	error: false,
	firstProject: undefined,
};

const setError =
	(error?: boolean): Action<State> =>
	({ setState }) => {
		setState({
			error,
		});
	};
const setFirstProject =
	(firstProject: FirstProject): Action<State> =>
	({ setState }) => {
		setState({
			firstProject,
		});
	};

export const actions = {
	setError,
	setFirstProject,
};
type Actions = typeof actions;

const store = createStore<State, Actions>({
	name: 'getting-started-page-is-first-project',
	initialState,
	actions,
});

export const useIsFirstProjectState = createHook(store);

export const useFirstProjectDetails = (): State => {
	const [data, { setError: setErrorState, setFirstProject: setFirstProjectDetails }] =
		useIsFirstProjectState();

	const { licensedProducts } = useTenantContext() || {};
	const hasJsmLicense = licensedProducts && licensedProducts[SERVICE_DESK];

	useEffect(() => {
		if (!hasJsmLicense || data.firstProject || data.error) {
			return;
		}
		getFirstProject()
			.then((response) => {
				setFirstProjectDetails(response);
			})
			.catch(() => {
				setErrorState(true);
			});
	}, [hasJsmLicense, setErrorState, setFirstProjectDetails, data.firstProject, data.error]);
	return data;
};
